import './FieldsetLegend.scss';

import { ReactNode } from 'react';
import withCx, { CxProps } from 'fe-core/util/withCx';

export interface FieldsetLegendProps {
  children?: ReactNode | string;
  dataTestId?: string;
}

const FieldsetLegend = ({
  children,
  dataTestId,
}: FieldsetLegendProps & CxProps) => (
  <legend
    className="FDBFieldsetLegend MuiFormLabel-root MuiFormLabel-colorPrimary"
    data-testid={dataTestId}
  >
    {children}
  </legend>
);

export default withCx<FieldsetLegendProps>('FDBFieldsetLegend')(FieldsetLegend);
